import Button from 'components/Form/Button';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'react-toastify';
import { POST } from 'services/api';
import styled, { keyframes } from 'styled-components';
import { Title } from 'ui/styled';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const ModalWrapper = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 16px;
`;

const ModalCard = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 440px;
  animation: ${fadeIn} 0.25s ease-out;
  overflow: hidden;
`;

const ModalHeader = styled.div`
  padding: 20px 24px 16px;
  border-bottom: 1px solid #e0e0e0;
`;

const ModalTitle = styled(Title)`
  font-size: 1.35rem;
  font-weight: 600;
  color: #000000ff;
  margin: 0;
`;

const ModalBody = styled.div`
  padding: 20px 24px;
`;

const ModalMessage = styled.p`
  font-size: 1rem;
  color: #424242;
  line-height: 1.6;
  margin: 0 0 24px 0;
  font-weight: 400;
`;

const ModalFooter = styled.div`
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background-color: #f9f9f9;
  border-top: 1px solid #e0e0e0;
`;

export const ActionButton = styled(Button)`
  min-width: 100px;
  height: 40px;
  font-weight: 500;
  font-size: 0.9375rem;
  border-radius: 8px;
  padding: 0 16px;
  text-transform: none;
  box-shadow: none !important;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export default function ModalCuradoriaFinanciamentos({
  isOpen,
  row,
  reload,
  onClose,
}) {
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    if (!loading && onClose) {
      onClose();
    }
  };
  const handleConfirm = async () => {
    if (!row?.id) {
      toast.error('ID da proposta não encontrado.');
      return;
    }
    setLoading(true);
    const payload = {
      propostaId: row.id,
      data: {
        curadoria_analise: 'Recusado',
      },
    };
    //console.log('ENVIANDO PAYLOAD:', payload)

    try {
      const result = await POST(
        '/financing-proposal/curadoria/reagendar',
        payload,
        true
      );
      if (result?.status === 'ok' || result?.success) {
        toast.success('Proposta removida da curadoria com sucesso!');
        await reload();
        handleClose();
      } else {
        toast.error(result?.erro || result?.message || 'Falha ao processar.');
      }
    } catch (error) {
      console.error('Erro na API:', error);
      toast.error('Erro ao comunicar com o servidor.');
    } finally {
      setLoading(false);
    }
  };
  if (!isOpen) return null;

  return createPortal(
    <ModalWrapper onClick={handleClose}>
      <ModalCard onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>Confirmação</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <ModalMessage>
            Esta ação vai <strong>remover esta proposta da curadoria</strong>.
            Deseja continuar?
          </ModalMessage>
        </ModalBody>
        <ModalFooter>
          <ActionButton
            onClick={handleClose}
            color="lightgrey"
            border
            disabled={loading}
          >
            Cancelar
          </ActionButton>
          <ActionButton
            color="blue"
            loading={loading}
            onClick={handleConfirm}
            disabled={loading}
          >
            Confirmar
          </ActionButton>
        </ModalFooter>
      </ModalCard>
    </ModalWrapper>,
    document.body
  );
}
